import { bookingApiSlice } from '../api/booking/bookingApiSlice';
import { seriesBookingApiSlice } from '../api/booking/seriesBookingApiSlice';
import Logger from '../common/logger';
import { store } from '../store/store';
import { CustomerMailRefusal, mailBlockedOf } from '../utils/customerMailGuard';
import { EditSeriesBookingPayload } from '../types/bookingCreation';

export const useEditSeriesBooking = (seriesId: string) => {
    return async (
        seriesData: EditSeriesBookingPayload,
        saveMode: 'save_only' | 'save_and_send_email',
    ): Promise<{ success: boolean, mailBlocked?: CustomerMailRefusal | null }> => {
        try {
            const response = await store.dispatch(
                seriesBookingApiSlice.endpoints.editSeriesBooking.initiate({
                    seriesId: seriesId,
                    data: seriesData,
                    saveMode: saveMode,
                }),
            ).unwrap();
            // `seriesBookingApiSlice` targets the new (ECS) backend and has
            // its own tag namespace. Booking list + details are still
            // served by `bookingApiSlice` against the legacy backend, so
            // we invalidate those tags here to trigger a refetch after a
            // successful series edit.
            store.dispatch(
                bookingApiSlice.util.invalidateTags(['bookingList', 'bookingDetails']),
            );
            // PO, 2026-10-30: saved, but the series mail may have been refused.
            return { success: true, mailBlocked: mailBlockedOf(response) };
        } catch (error) {
            Logger('editSeriesBooking').error(error);
            return { success: false };
        }
    };
};
